export type FieldError = typeof fieldError[keyof typeof fieldError];

export const fieldError = <const>{
  required: "Required",
  invalidFormat: "InvalidFormat",
  invalidValue: "InvalidValue",
};
